export const weekendDatesHighlighter = {
    id: 'datesHighliter',
}
